import { LegalLayout, LegalSection } from "../component/legal/LegalLayout";
import { siteConfig } from "../config/site";

export function TermsPage() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="Terms & Conditions"
      description={`Please review these Terms & Conditions before using ${siteConfig.companyName}.`}
    >
      <LegalSection>
        <p>
          By clicking "I agree" or "I accept," or by downloading, installing,
          or using our services, you indicate your agreement to the terms and
          conditions outlined in this document. If you do not agree to these
          terms and conditions, please refrain from accessing this website.
          This is a legally binding agreement between {siteConfig.companyName}{" "}
          and the customer applying for a loan.
        </p>
      </LegalSection>

      <LegalSection heading="Definitions">
        <p>
          The term "application" refers to the mobile software developed by
          our company, designed to provide end-users with access to{" "}
          {siteConfig.companyName}. "Lender" refers to a bank or non-banking
          financial company (referred to as NBFC) with which our company has
          entered into an agreement. The lender is responsible for approving,
          processing, and disbursing loans to customers through our platform.
          "We" refers to {siteConfig.companyName}.
        </p>
        <p>
          The term "loan" refers to the financial assistance that you can
          apply for through our platform. The loan is approved and provided
          by the Lender, subject to specific terms and conditions. The "Loan
          Agreement" denotes the agreement between the Lender and the
          customer, which may be in physical or digital form. The "App"
          represents the mobile application regularly made available to
          end-users.
        </p>
        <p>
          The "outstanding amount" encompasses the loan, interest, and fees
          owed by you to the lender on the due date. The "Platform" refers to
          both the mobile app and website. The "services" pertain to the
          lender's ability to grant, approve, and provide short-term loans
          through the platform. "User data" refers to any information,
          documents, or materials provided by you to our company. Finally,
          the "Website" corresponds to our company's online platform.
        </p>
      </LegalSection>

      <LegalSection heading="Service">
        <p>
          Our Services allow you to apply for a loan if you meet the
          requirements specified within the app. By utilizing our service,
          you acknowledge and agree that our company is responsible for
          collecting, verifying, tracking your location, confirming, and
          validating the user data, documents, and any other information
          required by the lender to approve the loan. You grant the lender
          permission to allow our company to collect and store your user data
          through the Mobile Application Form available on the platform.
        </p>
        <p>
          To access the Services, you will need to register and log in
          through your third-party platform account. During the application
          process, you will be required to submit and upload user
          information using the mobile app form. This information includes
          your name, email address, gender, and date of birth. Additionally,
          you will need to provide a password, a photograph, a contact
          number, your mobile phone number, and your login credentials from
          the third-party platform. This information also encompasses
          financial details such as bank statements, sources of income, bank
          account numbers, PAN cards, data necessary for customer compliance,
          data from credit information companies, and any other relevant
          information important to you. By signing up for these Services,
          you authorize us to import your personal information from other
          platforms and verify your credit history from the various Credit
          Bureaus such as CIBIL, CRIF Highmark, Equifax, etc.
        </p>
        <p>
          You acknowledge that we may request updates on your personal
          information periodically to ensure the accuracy of your KYC
          information in line with the RBI's KYC Guidelines. The Company
          undertakes all actions on your behalf with your explicit
          permission and strictly adheres to non-discriminatory practices.
          Once you have verified and uploaded your user information, the
          Company will proceed with the necessary verification procedures.
          Upon successful verification, you may become eligible for loan
          approval by the lender, subject to the lender's specific
          eligibility criteria and conditions. Subsequently, you will be
          required to complete additional forms such as the ECS (Electronic
          Clearing Service) or NACH (National Automated Clearing House)
          mandate, provide a check, or any other documentation requested by
          the lender. Once the required documents have been collected, the
          lender will disburse the loan amount in accordance with the terms
          outlined in the loan agreement.
        </p>
        <p>
          The approved loan amount will be disbursed to your account, based
          on the instructions provided in your mobile application. It is
          your responsibility to repay the loan amount to the lender on the
          specified date(s) indicated in your sanction letter. In the event
          that you uninstall or discontinue using our Services, you are
          still responsible for settling any outstanding amounts. You are
          solely accountable for any actions taken using your User Account,
          and the Company cannot be held liable for any consequences arising
          after your use of the Services. You agree to maintain the
          confidentiality of your User Account and are required to possess
          compatible devices and an internet connection compatible with the
          Platform and Services.
        </p>
      </LegalSection>

      <LegalSection heading="License">
        <p>
          To utilize the Services, you must download and install the app. By
          accessing and using the Services, you confirm that you are of
          legal age and possess the ability to understand, agree to, and
          abide by these Terms. You are granted a limited right to download,
          install, access, and use the App on your mobile phone, tablet, or
          other compatible devices. The App is licensed to you, not sold, and
          you may only use it in accordance with these Terms.
        </p>
      </LegalSection>

      <LegalSection heading="Restrictions">
        <p>
          By using our Platform and Services, you agree not to engage in any
          fraudulent activities or misuse the Platform for illegal purposes.
          Copying, selling, or reselling any part of the Platform is
          strictly prohibited. You are not allowed to upload any prohibited
          content or engage in behaviour that is harmful, threatening,
          abusive, harassing, or offensive. Impersonating others,
          unsolicited advertising or spam, uploading or distributing
          malicious software, or engaging in activities that disrupt or
          damage the Platform or associated networks is strictly prohibited.
          You must also comply with all applicable laws and regulations.
        </p>
      </LegalSection>

      <LegalSection heading="Content Available">
        <p>
          Please note that while using our Platform, we do not make any
          warranties regarding the available content, including data files,
          text, software, audio files, images, or videos. We are not
          responsible for any content posted or made available through the
          Platform, unless specifically stated otherwise in these Terms.
        </p>
      </LegalSection>

      <LegalSection heading="Proprietary Rights of the Company">
        <p>
          By registering with us, you grant us full rights, including
          intellectual property rights, to the content and the Platform. You
          also agree to respect and use any logos, service marks, or
          trademarks associated with our Platform. Unauthorized use of such
          intellectual property may violate applicable laws.
        </p>
      </LegalSection>

      <LegalSection heading="Termination">
        <p>
          The Company reserves the right to terminate these Terms under
          specific circumstances, including but not limited to: your
          violation of any of these Terms; our legal obligations; our
          decision to discontinue providing the Services or operating the
          Platform; or expiration of your license to use the App. Failure to
          settle the outstanding amount may result in the Company continuing
          to monitor your activities even after termination of these Terms
          or uninstallation of the App until all debts are fully paid.
        </p>
      </LegalSection>

      <LegalSection heading="Disclaimer of Warranties">
        <p>
          By utilizing the Services and Platform, you acknowledge and agree
          that you are doing so at your own risk. The Services and Platform
          are provided on an "as is" and "as available" basis. The Company
          does not provide any express or implied warranties, including but
          not limited to warranties of merchantability, fitness for a
          particular purpose, or non-infringement of intellectual property
          rights. We do not guarantee that the content will be
          comprehensive, complete, or accurate, nor do we guarantee that the
          Services or Platform will be consistently available, rapid,
          secure, or free from errors.
        </p>
      </LegalSection>

      <LegalSection heading="Indemnity">
        <p>
          By agreeing to this agreement, you agree to indemnify and hold
          harmless the Company, its subsidiaries and affiliates, officers,
          employees, agents, and representatives from any third-party claims
          or demands, including attorneys' fees, arising from your failure
          to comply with these Terms, your infringement of other users'
          rights, your unauthorized use or misuse of the Platform or
          Services, or any violation of applicable laws and regulations.
        </p>
      </LegalSection>

      <LegalSection heading="Limitations of Liability">
        <p>
          You acknowledge and accept that the Company, its directors,
          employees, agents, or service providers shall not be liable for
          any damages, whether direct, indirect, incidental, special,
          consequential, or exemplary, arising from the non-use or inability
          to use the Services, the inability to access the Platform, delays
          in the provision of Services, performance issues, damage or virus
          infection to your devices resulting from use of the Platform, or
          server issues related to the Services.
        </p>
      </LegalSection>

      <LegalSection heading="Force Majeure">
        <p>
          The Company shall not be held liable, under any circumstances, for
          any damages, losses, or disruptions suffered by the Platform due
          to the non-delivery of the Services as a result of natural events,
          forces, or causes beyond the reasonable control of the Company,
          including equipment failure, changes in regulations imposed by the
          Reserve Bank of India or any other government body, riots, storms,
          civil disturbances, electrical failure, floods, and other similar
          occurrences.
        </p>
      </LegalSection>

      <LegalSection heading="Cancellation & Refund Policy">
        <ul className="list-disc space-y-2 pl-5">
          <li>
            Pre-Disbursement Cancellation: Cancellation is allowed if the
            loan has been sanctioned but not disbursed.
          </li>
          <li>
            Cancellation After Disbursement: If the applicant wishes to
            cancel the service after loan disbursement within 24 hours, the
            principal amount must be repaid.
          </li>
          <li>
            Refund of Excess Payments: Any excess payments made will be
            refunded within 5-7 days after the reconciliation of loan
            repayment.
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="Choice of Law and Jurisdiction">
        <p>
          This agreement shall be construed as a legally binding contract
          and shall be governed by the laws of India, irrespective of any
          principles of conflict of laws. The Parties agree that any
          disputes arising from or in connection with this agreement shall
          be exclusively resolved by the courts having jurisdiction over the
          Company's registered office.
        </p>
      </LegalSection>

      <LegalSection heading="Miscellaneous">
        <p>
          By using our Services, you agree to these Terms, the Loan
          Agreement, the Mobile Application Form, and our Privacy Policy.
          These documents constitute the complete agreement between you and
          the Company. Any claims or causes of action arising from the
          Services or Terms must be filed within one year from the date of
          first use, or they will be deemed permanently barred. If any part
          of the Terms is deemed invalid by a court, the remaining terms
          will continue to be upheld to the fullest extent.
        </p>
      </LegalSection>

      <LegalSection heading="Violations">
        <p>
          If you encounter any concerns or complaints regarding these Terms,
          please don't hesitate to reach out to us
          {siteConfig.email ? (
            <>
              {" "}
              at{" "}
              <a
                href={`mailto:${siteConfig.email}`}
                className="font-semibold text-brand-purple underline"
              >
                {siteConfig.email}
              </a>
            </>
          ) : null}
          . We are committed to addressing any issues promptly and ensuring
          your satisfaction.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
